<template>
  <img
    v-show="imageSource"
    class="w-100"
    :src="imageSource"
    :alt="image.name"
    style="object-fit: cover"
  />
</template>
<script>
export default {
  name: "ImageReader",
  props: {
    image: {
      requried: true,
    },
  },
  data() {
    return {
      imageSource: null,
    };
  },
  methods: {
    readImage() {
      const $this = this;
      if (this.image instanceof Blob) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(this.image);
        fileReader.onload = function () {
          $this.imageSource = this.result;
        };
      } else {
        this.imageSource = this.image.url || "";
      }
    },
  },
  mounted() {
    this.readImage();
  },
  watch: {
    image() {
      this.readImage();
    },
  },
  updated() {
    this.readImage();
  },
};
</script>
